import { IRange } from '../../common/types';
import { Region } from '../../utils/regions';

export type Room =
  | 'bed'
  | 'oneRoom'
  | 'twoRoom'
  | 'threeRoom'
  | 'fourRoom'
  | 'fiveRoom'
  | 'large'
  | 'openPlan'
  | 'room'
  | 'share'
  | 'studio';

export const validRoomTypes: Room[] = [
  'studio',
  'oneRoom',
  'twoRoom',
  'threeRoom',
  'fourRoom',
  'bed',
  'fiveRoom',
  'large',
  'openPlan',
  'room',
  'share',
];

export function isRoomType(roomKey: string): roomKey is Room {
  return validRoomTypes.includes(roomKey as Room);
}

export function getRoomsFromString(rooms: string): Room[] {
  return rooms.split(',').filter(isRoomType) as Room[];
}

export interface IFilterQueryState {
  date: number | undefined;
  decoration: boolean;
  handOver: boolean;
  price: IRange;
  region: Region;
  rooms: Room[];
  square: IRange;
}

export interface IFilterState {
  dateVariations: number[];
  query: IFilterQueryState;
}

export const defaultFilterState: IFilterState = {
  dateVariations: [],
  query: {
    date: undefined,
    decoration: false,
    handOver: false,
    price: {
      max: undefined,
      min: undefined,
    },
    region: 'moscow',
    rooms: [],
    square: {
      max: undefined,
      min: undefined,
    },
  },
};
